import React, {useState, useEffect} from 'react';
import {goTo} from '@/utils';
import {useLinkedTabs} from '@/utils/hooks';
import TabSelector from './tab-selector';
import AgentContent from './agent-content';
import InvitationRewardContent from './invitation-reward-content';
import RulesContent from './rules-content';
import AgentNavBar from './agent-nav-bar';
import {useLogin, useUserInfo} from '@/utils/state-hooks';

const Agent = () => {
  const login = useLogin();
  const userInfo = useUserInfo();
  const [isAgent, setIsAgent] = useState<boolean | null>(null);

  // 获取代理状态
  useEffect(() => {
    const checkAgentStatus = () => {
      if (!login) {
        setIsAgent(false);
        return;
      }

      // 使用 globalStore.userInfo?.isAgent === 1 判断是否为代理
      setIsAgent(userInfo?.isAgent === 1);
    };

    checkAgentStatus();
  }, [login, userInfo]);

  const handleTabChangeIntercept = (newTabKey: string) => {
    // 如果切换到 agent tab 且用户不是代理，则跳转到 AgentPage
    if (newTabKey === 'agent' && isAgent === false) {
      goTo('AgentPage');
      return;
    }

    // 正常切换标签
    handleTabChange(newTabKey);
  };

  const {tabKey, onTabChange: handleTabChange} = useLinkedTabs({
    routeParamKey: 'tabKey',
    tabsData: [
      {tabKey: 'agent'},
      {tabKey: 'invitation-reward'},
      {tabKey: 'rules'},
    ],
  });

  // 优先使用 tabKey（来自路由参数），直接使用 tabKey 来决定渲染内容
  const currentTab = tabKey;

  const renderContent = () => {
    switch (currentTab) {
      case 'agent':
        return <AgentContent />;
      case 'invitation-reward':
        return <InvitationRewardContent />;
      case 'rules':
        return <RulesContent />;
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col w-[23.4375rem] h-full bg-bg">
      <AgentNavBar />
      <TabSelector
        activeTab={currentTab || 'agent'}
        onChange={handleTabChangeIntercept}
      />
      {renderContent()}
    </div>
  );
};

export default Agent;
